import { route } from 'quasar/wrappers'
import VueRouter from 'vue-router'
import { StoreInterface } from '../store'
import routes from './routes'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

export default route<StoreInterface>(function ({ Vue }: any) {
  Vue.use(VueRouter)

  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as is and change from quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  })

  // this checks the router
  Router.beforeEach((to, from, next) => {
    //retrieves the current path of the url (did not use to.path.name because it does not detect '/#')
    const currentPath: string = window.location.pathname
    // gets the path of what page the user wants to go.
    const destinationPath: string = to.path
    //if one slash is not detected
    if (currentPath !== '/') {
      // Redirect the user in a cleaner url
      window.location.href = `/#${destinationPath}`
    } else {
      next()
    }
  })

  return Router
})
